import { render, staticRenderFns } from "./DetailAt.vue?vue&type=template&id=19352313"
import script from "./DetailAt.vue?vue&type=script&lang=js"
export * from "./DetailAt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports